<template>
  <DBox
    :id="'cmp-distribution-order-sidewindow-packaging_shipping'"
    :addButton="false"
    :addLink="false"
    @add_click="onAddOrderLines"
  >
    <div
      class="ut-fc ut-fh"
      v-if="
        selectedOrder &&
        selectedOrder.order_details_tab_summary &&
        selectedOrder.order_details_tab_summary.order &&
        selectedOrder.order_details_tab_summary.order.order_id
      "
    >
      <div class="ut-fc ut-flex-1" style="height: calc(100% - 248px)">
        <NTable
          class="dbox1"
          id="distribution-order-sidewindow-packaging_shipping"
          :config="tableConfig"
          :headers="Headers"
          :items="list"
          :showNoItems="false"
        >
          <template v-slot:item="{ item, tdcon }">
            <tr>
              <td @click="onClickCatalogNo(item)" v-bind="tdcon('product')">
                <span class="txtov ut-link ut-text-accent5">{{
                  item["catalog_no"]
                }}</span>
              </td>
              <td v-bind="tdcon('artist')">
                <span class="txtov">{{ item["release_alt_artist"] }}</span>
              </td>

              <td v-bind="tdcon('title1')">
                <span class="txtov">{{ item["release_alt_title"] }}</span>
              </td>
              <td v-bind="tdcon('format')">
                <span>{{ item["format_name"] }}</span>
              </td>
              <td v-bind="tdcon('promo_foc')">
                <template v-if="item['promo_foc'] != null">
                  <span v-if="item['promo_foc'] == 1">Promo</span>
                  <span v-else>FOC</span>
                </template>
              </td>
              <td
                v-if="selectedOrder.showStockColumn"
                v-bind="tdcon('available_stock')"
              >
                <span>{{ item["account_stock_unpacked_unreserved"] }}</span>
              </td>
              <td v-bind="tdcon('qty')">
                <span>{{ item["order_qty"] }}</span>
              </td>
              <td v-bind="tdcon('shortfall')">
                <TextField2
                  type="number"
                  class="dbox1"
                  id="shortfall_qty"
                  :showLabel="false"
                  :disabled="false"
                  :value="item['shortfall_qty']"
                  :bb="'0px'"
                  :ta="'right'"
                  @change="(e) => onTextFieldChange(e, item)"
                />
              </td>

              <td v-bind="tdcon('final_qty')">
                <span>{{ item["qty"] }}</span>
              </td>

              <td
                v-if="selectedOrder.showStatusColumn"
                v-bind="tdcon('packing_status')"
                :title="getStatusLabel(item)"
              >
                <div class="dt-icon-container" v-if="getStatusIcon(item)">
                  <img
                    :src="`static/icons/${getStatusIcon(item)}.svg`"
                    class="dt-icon v5 s1"
                    :alt="getStatusIcon(item)"
                  />
                </div>
              </td>
              <td
                v-if="selectedOrder.showStatusColumn"
                v-bind="tdcon('backorder_status')"
                :title="getStatusLabel(item)"
              >
                <span class="ut-text-error" v-if="getBackorderFlag(item)">
                  {{ getBackorderFlag(item) }}
                </span>
              </td>
              <td v-bind="tdcon('options')">
                <div class="dt-icon-container">
                  <img
                    @click.stop="(e) => deleteOrderLine(item)"
                    src="static/icons/delete.svg"
                    class="dt-icon v5 s1"
                  />
                </div>
              </td>
            </tr>
          </template>
        </NTable>
      </div>
      <div
        style="
          min-height: 48px;
          width: 100%;
          padding-right: 10px;
          background-color: white;
        "
        class="ut-flex ut-jend"
      >
        <div>
          <span style="color: var(--text-secondary)"
            >Value :<b style="color: #000">
              {{
                $dft.curr(
                  (selectedOrder &&
                    selectedOrder.order_details_tab_summary &&
                    selectedOrder.order_details_tab_summary.orderObj &&
                    selectedOrder.order_details_tab_summary.orderObj
                      .order_value) ||
                    0
                )
              }}
              {{ selectedOrder.orderCurrency }}
            </b>
          </span>
        </div>
      </div>

      <div
        class="ut-flex"
        style="
          min-height: 200px;
          padding-bottom: 10px;
          padding-left: 10px;
          width: 100%;
        "
      >
        <div class="ut-flex-1">
          <TextField
            id="subject"
            class="mb10"
            :label="$t('deal_memo')"
            :placeholder="`${this.$t('deal_memo')}`"
            :textarea="true"
            :height="90"
            :showLabel="false"
            :disabled="true"
            :value="selectedOrder.order_details_tab_summary.account.deal_memo"
            :rightIcon="'static/icons/question.svg'"
            :bb="'none'"
            :icon="'search-blue'"
          />
          <TextField
            id="subject"
            class="m0"
            :label="$t('shipping_info')"
            :placeholder="`${$dft.capHead($t('shipping_info'))}`"
            :textarea="true"
            :height="90"
            :showLabel="false"
            :disabled="true"
            :value="
              selectedOrder.order_details_tab_summary.account.shipping_info
            "
            :rightIcon="'static/icons/question.svg'"
            :bb="'none'"
            :icon="'search-blue'"
          />
        </div>
        <!-- flex-end: right;justify-content: flex-end; -->
        <div
          class="ut-flex ut-fh ut-flex-1 ut-jend ut-aend"
          style="padding-right: 10px"
        >
          <div
            class="ut-fh ut-fc ut-jbetween ut-aend"
            style="flex: 1; margin-left: 10px; align-items: flex-end"
          >
            <ShippingSummary
              @changed="onChange"
              :selectedOrder="selectedOrder"
              @packStatusChanged="(e) => $emit('packStatusChanged', e)"
            />

            <div class="ut-flex">
              <button v-if="selectedOrder.show_button_auto_backorder" @click="onAutoBackordersClick" class="dt-button v5 s8">
                {{ $t("auto_backorder") }}
              </button>
              <button v-if="selectedOrder.show_status_button_change_pickup_status" @click="onPickStatusClick" class="dt-button v5 s8">
                {{ $dft.capHead($t("change_pick_status")) }}
              </button>
              <button @click="onDocumentClick" class="dt-button v5 s8 ut-mr-0">
                {{ $dft.capHead($t("documents")) }}
              </button>
            </div>
          </div>
        </div>
        <!-- @change="onTextFieldValueChange" -->
      </div>
    </div>
  </DBox>
</template>
<script>
import NTable from "../../../../plugins/datatable/datatable";
import { createNTableConfig } from "../../../../plugins/datatable";
import DBox from "@dtplugins/dbox/dbox";
import { createTableHeader } from "../../../../plugins/datatable";
import { ConfirmationService } from "../../../../dt-plugins/confirmation/confirmation.service";
import { invoiceListLDTRoutes } from "../../../accounting/router/routes";
import ShippingSummary from "./shipping-summary.vue";
import { productsListLDTRoutes } from "../../../catalog/router/routes";

export default {
  props: {
    selectedOrder: {
      type: Object,
    },
  },
  components: {
    NTable,
    DBox,
    ShippingSummary,
  },
  data: function () {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true,
      },

      tableConfig: createNTableConfig({
        headerStyle: 3,
        fullHeight: true,
      }),
    };
  },
  computed: {
    Headers: function () {
      return [
        createTableHeader("product", { f: 1.5 }),
        createTableHeader("artist", { f: 1.5 }),

        createTableHeader("title1", { f: 1.5, text: this.$t("title") }),
        createTableHeader("format", { ta: "right" }),
        createTableHeader("promo_foc", {}),
        // createTableHeader("available_stock", {
        //         ta: "right",
        //         minw: 120,
        //         mw: 120,
        //       }),
        ...(this.selectedOrder?.showStockColumn
          ? [
              createTableHeader("available_stock", {
                ta: "right",
                minw: 120,
                mw: 120,
              }),
            ]
          : []),
        createTableHeader("qty", { ta: "right" }),
        createTableHeader("shortfall", { ta: "right" }),
        createTableHeader("final_qty", { ta: "right" }),
        ...(this.selectedOrder?.showStatusColumn
          ? [createTableHeader("packing_status", { text: false, mw: 30 })]
          : []),
        ...(this.selectedOrder?.backorderBuildCurrently
          ? [createTableHeader("backorder_status", { text: false, mw: 38 })]
          : []),
          createTableHeader("options", { text:false ,mw:30}),
      ];
      // return this.selectedOrder?.showStockColumn
      //   ? [
      //       createTableHeader("product", { f: 1.5 }),
      //       createTableHeader("artist", { f: 1.5 }),

      //       createTableHeader("title1", { f: 1.5, text: this.$t("title") }),
      //       createTableHeader("format", { ta: "right" }),
      //       createTableHeader("promo_foc", {}),
      //       createTableHeader("stock", { ta: "right" }),
      //       createTableHeader("available_stock", {
      //         ta: "right",
      //         minw: 120,
      //         mw: 120,
      //       }),
      //       createTableHeader("qty", { ta: "right" }),
      //       createTableHeader("shortfall", { ta: "right" }),
      //       createTableHeader("final_qty", { ta: "right" }),
      //       createTableHeader("packing_status", { text: false, mw: 30 }),
      //       createTableHeader("backorder_status", { text: false, mw: 38 }),
      //     ]
      //   : [
      //       createTableHeader("product", { f: 1.5 }),
      //       createTableHeader("artist", { f: 1.5 }),

      //       createTableHeader("title1", { f: 1.5, text: this.$t("title") }),
      //       createTableHeader("format", { ta: "right" }),
      //       createTableHeader("promo_foc", {}),
      //       createTableHeader("stock", { ta: "right" }),
      //       createTableHeader("qty", { ta: "right" }),
      //       createTableHeader("shortfall", { ta: "right" }),
      //       createTableHeader("final_qty", { ta: "right" }),
      //       createTableHeader("packing_status", { text: false, mw: 30 }),
      //       createTableHeader("backorder_status", { text: false, mw: 38 }),
      //     ];
    },

    list: function () {
      return this.selectedOrder?.packing_orderlines?.orderlines || [];
    },

    totalValue: function () {
      if (this.list.length > 0) {
        return this.list.reduce((accum, cur) => {
          accum = parseFloat(accum) + parseFloat(cur.total);
          return accum.toFixed(2);
        }, 0.0);
      }
    },
  },

  methods: {
    
    deleteOrderLine: async function (item) {
      // const confirmationResult = await confirmDelete(
      //   this.$t("order_line"),
      //   `#${item.order_id}-${item["catalog_no"]} | ${item.order_qty}`
      // );

      // if (confirmationResult == "OK") {
        this.$emit("delete", item);
      // }
    },
    onClickCatalogNo: function (item) {
      console.log(item);
      this.$router.push({
        name: productsListLDTRoutes.names.tab,
        params: {
          product_id: item.product_id,
          tab: "overview",
        },
      });
    },
    onChange: function (payload) {
      this.$emit("changeShippingSummary", payload);
    },
    onTextFieldChange: function (e, item) {
      const { name, value } = e;

      this.$emit("changed", { name, value, item });
    },

    onAddOrderLines: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "add_order_line",
          order_id:
            this.selectedOrder?.order_details_tab_summary?.order.order_id,
        },
      });
    },

    onDiscountClick: function () {},
    onDocumentClick: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "documents_modal",
          order_id:
            this.selectedOrder?.order_details_tab_summary?.order.order_id,
        },
      });
    },
    onPickStatusClick: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "pick_status_modal",
          order_id:
            this.selectedOrder?.order_details_tab_summary?.order.order_id,
        },
      });
    },

    onAutoBackordersClick: function () {
      // const orderlines =
      //   this.selectedOrder?.packing_orderlines?.package_orderlines?.map((e) => {
      //     return {
      //       orderline_id: e.orderline_id,
      //       status: e.status,
      //       product_id: e.product_id,
      //       product_allowed_country_account_show:
      //         e.product_allowed_country_account_show,
      //       account_stock_unpacked_unreserved:
      //         e.account_stock_unpacked_unreserved,
      //       order_qty: e.order_qty,
      //     };
      //   });

      // const payload = {
      //   orderlines: orderlines,
      //   order_id: this.selectedOrder?.order_details_tab_summary?.order.order_id,
      // };
      this.$emit("autoBackOrder", true);
    },

    getStatusLabel(item) {
      // console.log(
      //   "orderline_pack_status",
      //   this.selectedOrder?.order_details_tab_packing_shipping
      //     ?.orderline_pack_status
      // );

      return this.selectedOrder?.order_details_tab_packing_shipping?.orderline_pack_status?.find(
        (e) => {
          return +e.value == +item.status;
        }
      )?.label;
    },

    // getStatusText(item) {
    //   const status = `${item.status}`;
    //   switch (status) {
    //     case "1":
    //       return "O";
    //     case "2":
    //       return "BO";
    //     case "3":
    //       return "P";
    //     default:
    //       return "";
    //   }
    // },
    getStatusIcon(item) {
      if (+item.qty > 0) {
        const status = `${item.status}`;
        switch (status) {
          case "1":
            return "open";
          case "2":
            return "reserved";
          case "3":
            return "packed";
          default:
            return "";
        }
      } else {
        return "";
      }
    },
    getBackorderFlag(item) {
      if (+item["shortfall_qty"] > 0) {
        return "BO";
      } else {
        return "";
      }
    },
  },
};
</script>
